async function makePost(chat_id) {
    try {
        const response = await axios.post('/make_post/'+chat_id);

        $('#post-posted').fadeIn(300, function(){
            $(this).fadeOut(300);
        });
    } catch (error) {
        alert('Произошла ошибка на сервере: ' + error.response.data.message);
    }
}

$("[data-post]").on('click', function(e) {
    e.preventDefault();
    let chat_id = $(this).data('post');
    makePost(chat_id).then(r => console.log('done'));
});
